<template>
	<div>
		<div class="text-subtitle-2 mb-2">
			<v-icon small left>mdi-comment-text-multiple-outline</v-icon>Messaggi
		</div>

		<div v-if="loading" class="text-center pa-4">
			<v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
		</div>

		<div v-else>
			<div v-if="!comments.length" class="grey--text font-italic mb-3">
				Nessun messaggio. Scrivi qui per comunicare con il team.
			</div>

			<div
				v-for="c in comments"
				:key="c.id"
				class="d-flex mb-3"
				:class="c.mine ? 'justify-end' : 'justify-start'"
			>
				<div
					class="pa-2 px-3 rounded"
					:class="c.mine ? 'primary white--text' : 'grey lighten-3'"
					style="max-width: 80%"
				>
					<div class="text-caption font-weight-bold mb-1" :class="c.mine ? 'white--text' : ''">
						{{ c.mine ? 'Tu' : c.author }}
					</div>
					<div style="word-break: break-word" v-html="sanitizeHtml(c.text)"></div>
					<div class="text-caption mt-1" :class="c.mine ? 'white--text' : 'grey--text'">
						{{ formatDate(c.created_at) }}
					</div>
				</div>
			</div>
		</div>

		<v-divider class="my-3"></v-divider>

		<v-textarea
			v-model="newText"
			label="Scrivi un messaggio"
			outlined
			rows="2"
			auto-grow
			hide-details
			class="mb-2"
		></v-textarea>
		<div class="text-right">
			<v-btn color="primary" :loading="sending" :disabled="!newText.trim()" @click="send">
				<v-icon left small>mdi-send</v-icon>Invia
			</v-btn>
		</div>
	</div>
</template>

<script>
import { sanitizeHtml } from '@/utils/sanitizeHtml'

export default {
	name: 'PortalComments',
	props: {
		itemId: { type: [String, Number], required: true }
	},
	data() {
		return {
			comments: [],
			newText: '',
			loading: false,
			sending: false
		}
	},
	created() {
		this.load()
	},
	methods: {
		sanitizeHtml,
		async load() {
			this.loading = true
			try {
				const resp = await this.axios.get('portal/items/' + this.itemId + '/comments')
				if (resp.data.success) this.comments = resp.data.data || []
			} catch (e) {
				// silenzioso
			} finally {
				this.loading = false
			}
		},
		async send() {
			const text = this.newText.trim()
			if (!text) return
			this.sending = true
			try {
				const resp = await this.axios.post('portal/items/' + this.itemId + '/comments', { text })
				if (resp.data.success) {
					this.comments.push(resp.data.data)
					this.newText = ''
					this.$emit('posted')
				}
			} catch (e) {
				this.$store.commit('setSnackbarError')
			} finally {
				this.sending = false
			}
		},
		formatDate(date) {
			if (!date) return ''
			return new Date(date).toLocaleDateString('it-IT', {
				day: '2-digit', month: '2-digit', year: 'numeric',
				hour: '2-digit', minute: '2-digit'
			})
		}
	}
}
</script>
